/* eslint no-undef: "error" */

import React, { useState, useEffect } from "react";
import { object, array, string, number } from "prop-types";
import assetify from "@quintype/framework/assetify";
import { connect } from "react-redux";
import get from "lodash/get";

import StoryTitleInfo from "../../molecules/StoryTitleInfo";
import StoryContent from "../../molecules/StoryContent";
import StoryHeroImage from "../../atoms/StoryHeroImage";
import DefaultImage from "../../atoms/CardImage/default.svg";
import StoryPageMetaData from "../../molecules/StoryPageMetaData";
import DfpAd from "../../dfp-ad";

import "./blank.m.css";

const BlankStoryTemplate = ({
  story,
  summary,
  relatedStories,
  imageElements,
  startingCard,
  publisherAttributes,
  jwtToken,
  scrollIndex,
}) => {
  const slicedStoryCards = story.cards.slice(startingCard);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    global.deviceWidth < 876 && setIsMobile(!isMobile);
  }, []);

  return (
    <div styleName="wrapper" data-testid="related-story" className={`story-------${scrollIndex}`}>
      <div styleName="ad-slot" className="top-ad">
        <DfpAd
          adtype={publisherAttributes === "en" ? "EnPalo_ROS_728x90_T1" : "News_728x90_T1"}
          targetStory={story}
          slotId={`story_${scrollIndex}-t1`}
        />
      </div>
      <div styleName="meta-content" className="print-meta-content">
        <div>
          <StoryTitleInfo
            story={story}
            summary={summary}
            datatrackingcategory="Story Sub Section"
            datatrackingaction="Click"
          />
          <StoryPageMetaData story={story} lang={publisherAttributes.lang} />
        </div>
        {typeof window !== "undefined" && !isMobile && (
          <DfpAd
            adtype={publisherAttributes.lang === "en" ? "EnPalo_ROS_336x280_R1" : "News_336x280_R1"}
            targetStory={story}
            slotId={`story_${scrollIndex}-r1`}
          />
        )}
      </div>
      {story["hero-image-s3-key"] && <StoryHeroImage story={story} imageWidth={isMobile ? [375] : [1140]} />}
      <StoryContent
        story={story}
        slicedStoryCards={slicedStoryCards}
        relatedStories={relatedStories}
        imageElements={imageElements}
        showMetadata={false}
        isMobile={isMobile}
        jwtToken={jwtToken}
        datatrackingcategory="Story Sub Section"
        datatrackingaction="Click"
        scrollIndex={scrollIndex}
      />
      {scrollIndex < 4 && (
        <div className="sun-logo">
          <img src={`${assetify(DefaultImage)}`} alt="sun" />
        </div>
      )}
    </div>
  );
};

const BlankStory = ({
  story,
  relatedStories,
  summary,
  imageElements,
  startingCard,
  publisherAttributes,
  jwtToken,
  scrollIndex,
}) => {
  return (
    <div className="story-grid">
      <BlankStoryTemplate
        story={story}
        relatedStories={relatedStories}
        summary={summary}
        imageElements={imageElements}
        startingCard={startingCard}
        publisherAttributes={publisherAttributes}
        jwtToken={jwtToken}
        scrollIndex={scrollIndex}
      />
    </div>
  );
};

BlankStoryTemplate.propTypes = {
  story: object,
  relatedStories: array,
  summary: string,
  imageElements: array,
  startingCard: number,
  publisherAttributes: object,
  jwtToken: string,
  scrollIndex: number,
};

BlankStory.propTypes = {
  story: object,
  relatedStories: array,
  summary: string,
  imageElements: array,
  startingCard: number,
  publisherAttributes: object,
  jwtToken: string,
  scrollIndex: number,
};

const mapStateToProps = (state) => ({
  publisherAttributes: get(state, ["qt", "config", "publisher-attributes"], {}),
  jwtToken: get(state, ["userReducer", "jwt_token"], null),
});

export default connect(mapStateToProps, null)(BlankStory);
